export default "__VITE_ASSET__06206f10__"